// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vMzx","label":"styles_label__2k-4j"};